import React from 'react';
import { Box, Text, Grid, Image,} from '@chakra-ui/react';

const Card = props => {
  const { img, name, job } = props;
  return (
    <>
      <Box
        w="100%"
        h="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="column"
      >
        <Image src={img} alt="profile" />
        <Text
          fontWeight="500"
          fontSize={['1rem', '1.25rem']}
          textAlign="center"
          fontFamily='Duplicate Sans'
          whiteSpace="nowrap"
          color="#1f1f29"
        >
          {name}
        </Text>
        <Text
          fontSize=".95rem"
          mt=".75rem"
          mb=".75rem"
          textAlign="center"
          color="#445368"
        >
          {' '}
          {job}
        </Text>
      </Box>
    </>
  );
};

const Service = () => {
  return (
    <Box
      bg="#fff"
      w="full"
      h="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      p={['1.5rem','3rem','4rem' ,'6rem']}
    >
      <Text
        fontSize={['1.35rem', '2rem', '2rem', '3rem']}
        mt="3rem"
        textAlign="center"
        fontFamily='Duplicate Sans'
        fontWeight="500"
      >
        Why people and businesses <br/> choose and trust NeemblePay
      </Text>

      <Grid
        pb="2rem"
        gap="12"
        mt={['2rem',"4rem"]}
        templateColumns={[
          'repeat(1,1fr)',
          'repeat(1,1fr)',
          'repeat(1,1fr)',
          'repeat(3,1fr)',
        ]}
      >
        <Card
          img="/Biometric 1.svg"
          name="Biometric Payment Option"
          job="We offer a seamless biometric transaction 
method. You can withdraw cash and 
also make online payments directly 
with just your biometrics."
        />
        <Card
          img="/insurance.svg"
          name="Secure and Encrypted"
          job="Every of our services on the Neemble platform 
is built just for you. We want you to have 
easy access to your funds and the 
seamlessness it provides.

"
        />
        <Card
          img="/builtforyou.svg"
          name="Built for You"
          job="Security of our customers funds is our top 
priority. Our platform is built with 
streamlined security users’ data 
and bank details"
        />
      </Grid>
    </Box>
  );
};

export default Service;
